export default "__VITE_ASSET__05e456b0__"